'use client'
import { useTranslate } from '../../hooks'
import {
  Card,
  CenterBox,
  Col,
  Icon,
  Row,
  Skeleton,
  Typography,
} from '@repo/ui/components'
import { useRouter } from '../../i18n/navigation'
import { useEffect } from 'react'
import { PaymentType } from '../'

export const TransactionSuccess = ({
  amount,
  rrn,
  isLoading,
}: {
  amount?: number
  rrn?: string
  isLoading?: boolean
}) => {
  const { t } = useTranslate()
  const { push } = useRouter()

  useEffect(() => {
    const timer = setTimeout(() => {
      push('/history/balance')
    }, 3000)
    return () => clearTimeout(timer)
  }, [push])

  return (
    <Card className=' max-w-screen-2xs w-full m-auto flex justify-center items-center'>
      <CenterBox className='h-full w-full '>
        <Col className='gap-md items-center'>
          <CenterBox className='bg-positive-surface-100/20 rounded-full'>
            <Icon
              name='CheckCircleGhost'
              className='size-full rounded-full'
              size='2xl'
              color='fill-positive-surface-100'
            />
          </CenterBox>

          <Typography
            size='lg'
            weight='bold'
            color='text-positive-surface-100'
            className='text-center'
          >
            {t('common_transaction_success_title')}
          </Typography>

          <Row className='justify-between mt-md'>
            <Typography
              size='sm'
              weight='regular'
              color='text-neutral-surface-80'
            >
              {t('common_transaction_amount')}
            </Typography>
            {isLoading ? (
              <Skeleton className='w-10 h-4' />
            ) : (
              <PaymentType
                size='sm'
                color='text-neutral-surface-80'
                isBold={false}
                value={amount}
              />
            )}
          </Row>
          <Row className='justify-between mt-md'>
            <Typography
              size='sm'
              weight='regular'
              color='text-neutral-surface-80'
            >
              {t('common_transaction_reference')}
            </Typography>
            <Typography
              size='sm'
              weight='bold'
              color='text-neutral-surface-80'
              className='wrap-anywhere ps-2xs'
            >
              <span className='px-2xs'>{rrn ?? '-'}</span>
            </Typography>
          </Row>
          <Typography
            size='xs'
            weight='regular'
            color='text-neutral-surface-60'
            className='text-center animate-[pulse_1s_ease-in-out_infinite] mb-lg'
          >
            {t('common_transaction_success_description')}
          </Typography>
        </Col>
      </CenterBox>
    </Card>
  )
}
